import type { WithdrawalPolicySettingsDto } from '@shared/api/contracts';

export const COOLING_MAX_MINUTES = 30 * 24 * 60;
export const COOLING_MAX_SECONDS = COOLING_MAX_MINUTES * 60;

export interface CoolingSettings {
  version: number;
  coolingPeriodSeconds: number;
}

export interface CoolingDurationParts {
  hours: number;
  minutes: number;
  seconds: number;
}

const isNonNegativeInteger = (value: unknown): value is number =>
  typeof value === 'number' && Number.isInteger(value) && value >= 0;

/** Ответ GET без валидного version/coolingPeriodSeconds считаем некорректным: срок не подставляем. */
export const parseCoolingSettings = (
  data: Partial<WithdrawalPolicySettingsDto> | null | undefined,
): CoolingSettings | null => {
  if (!data || typeof data !== 'object') return null;
  const { version, coolingPeriodSeconds } = data;
  if (!isNonNegativeInteger(version) || !isNonNegativeInteger(coolingPeriodSeconds)) return null;
  if (coolingPeriodSeconds > COOLING_MAX_SECONDS) return null;
  return { version, coolingPeriodSeconds };
};

/** Фактическая длительность без округления: 86340 → 23 ч 59 мин. Часы не переводятся в дни. */
export const getCoolingDurationParts = (totalSeconds: number): CoolingDurationParts => ({
  hours: Math.floor(totalSeconds / 3600),
  minutes: Math.floor((totalSeconds % 3600) / 60),
  seconds: totalSeconds % 60,
});

/** Минуты из поля ввода → секунды для PATCH; null, если значение недопустимо. */
export const minutesInputToSeconds = (input: string): number | null => {
  if (!/^\d+$/.test(input.trim())) return null;
  const minutes = Number(input.trim());
  if (!Number.isSafeInteger(minutes) || minutes > COOLING_MAX_MINUTES) return null;
  return minutes * 60;
};
